<template>
    <div class="table-list">
        <div>
            <ul class="table hd">
                <li class="table-row">
                    <div class="table-row__cell position">设备位置</div>
                    <div class="table-row__cell content">车牌号码</div>
                    <div class="table-row__cell direction">方向</div>
                    <div class="table-row__cell warningTime">进/出时间</div>
                </li>
            </ul>
        </div>
        <vue-seamless-scroll class="recordlist"
            v-if="data && data.length"
            :data="data"
            :class-option="classOption">
            <ul  class="table">
                <li class="table-row" v-for="item in data" :key="item.id">
                    <div class="table-row__cell position">{{item.position}}</div>
                    <div class="table-row__cell content">{{item.carCode}}</div>
                    <div class="table-row__cell direction">{{item.direction}}</div>
                    <div class="table-row__cell warningTime">{{item.recordTime}}</div>
                </li>
            </ul>
        </vue-seamless-scroll>
        <div v-else class="empty">
            暂无数据
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default () {
                return []
            }
        }
    },
    data () {
        return {
            classOption: {
                singleHeight: 44,
            }
        }
    }
}
</script>

<style lang="less" scoped>
.recordlist {
    height: 352px;
    overflow: hidden;
}
.empty {
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 352px;
    text-align: center;
}
.table-list {
    margin: 6px 16px 0px;
}
.table {
    font-size: 12px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #40D5FF;
    .table-row {
        display: flex;
        height: 44px;
        align-items: center;
        background: rgba(6, 41, 57, 1);
        padding: 0 12px;
        &:nth-child(odd) {
            background: rgba(7, 51, 72, 1);
        }
        &__cell {
            white-space: nowrap;
            overflow: hidden;
            flex: none;
            &.position {
                width: 117px;
            }
            &.content {
                width: 80px;
                padding-left: 24px;
            }
            &.direction {
                width: 121px;
                padding-left: 24px;
            }
        }
    }
    &.hd {
        .table-row {
            background: rgba(7, 51, 72, 1)!important;
            color: #fff;
        }
    }
}
</style>